// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,<svg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23000000%27><path fill-rule=%27evenodd%27 d=%27M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z%27/></svg>", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3Csvg width=%2715%27 height=%278%27 viewBox=%270 0 10 8%27 fill=%27none%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cpath d=%27M1.18333 0.921875L5 4.74337L8.825 0.921875L10 2.09836L5 7.10468L0 2.09836L1.18333 0.921875Z%27 fill=%27%23666666%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("data:image/svg+xml,%3Csvg width=%2715%27 height=%278%27 viewBox=%270 0 10 8%27 fill=%27none%27 stroke=%27rgb%2844 146 230%29%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cpath d=%27M1.18333 0.921875L5 4.74337L8.825 0.921875L10 2.09836L5 7.10468L0 2.09836L1.18333 0.921875Z%27 fill=%27%23666666%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html {
  height: 100%;
}

body {
  height: 100%;
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen",
    "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue",
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-family: "Inter", sans-serif !important;
  font-optical-sizing: auto;
  --bs-primary: #1b8eed;
  --bs-primary-rgb: 27, 142, 237;
  --color-dark-1: #283045;
  --bg-light-1: #eee;
  --border-light: #ddd;
  --bs-border-color: #d5d5d5;
}

.btn-primary {
  --bs-btn-bg: #1b8eed;
  --bs-btn-hover-bg: #3299ef;
}

.btn:disabled {
  --bs-btn-disabled-bg: #DDDDDD;
  --bs-btn-disabled-color: #AAAAAA;
  --bs-btn-disabled-border-color: #AAAAAA;
}

#home_page {
  .app-header {
    padding-left: 24px;
    padding-right: 24px;
    position: relative;
    background: rgba(0, 0, 0, 0.5);
  }

  .home-content {
    position: relative !important;
    z-index: 1;

    .hero-wrapper {
      margin-top: 70px;
      z-index: 1;

      align-items: center;

      .hero-message {
        text-align: center;
        margin: 6em 0 !important;
      }

      .product {
        text-align: center;

        .l1 {
          font-size: 2em;

          img {
            height: 32px;
          }
        }

        .l2 {
          margin: 5px 0;
          font-style: italic;
          font-size: 1.25em;
        }

        .l3 {
          font-size: 1.5em;
          font-weight: bold;
        }
      }

      .hero-points {
        background: rgba(0, 0, 0, 0.5);
        border: 1px solid #666;
        border-radius: 5px;
        margin-top: 3em;

        ul {
          list-style: none;
          padding: 0;
          margin: 0;

          li {
            padding: 10px 10px;
            border-bottom: 1px solid #666;

            .main {
              font-size: 1.5em;
              font-weight: bold;
            }

            .sub {
              font-size: 1em;
              color: #999;
            }
          }
        }
      }

      @media (min-width: 768px) {
        .hero-message {
          text-align: left;
        }

        hr {
          display: none;
        }
      }
    }

    .benefits {
      background: #283039;

      .list {
        @media (min-width: 720px) {
          flex-direction: column !important;
          align-items: center;
        }
      }

      .item {
        border-radius: 5px;
        border-color: #44515f !important;
        color: #fff;

        h4 {
          font-size: 1.5em;
        }

        p {
          margin: 0 !important;
          color: #ccc;
        }
      }
    }

    .cta {
      padding: 50px 0;

      .primary {
        font-size: 1.5em !important;
        font-weight: bold;
      }
    }
  }
}

.fh {
  height: 100vh;
  overflow: scroll;
}

.project-header {
  min-height: 50px;
}

.App>div {
  height: 100%;
}

.left-pane {
  width: 250px;
  min-width: 250px;
  background: var(--bg-light-1);
  border-right: 1px solid #ddd;
  z-index: 1;
}

.right-pane {
  width: 300px;
  min-width: 300px;
  background: var(--bg-light-1);
  border-left: 1px solid #ddd;
  z-index: 1;

  &.wide {
    width: 500px;
  }
}

.border-bottom {
  border-bottom: 1px solid #ddd !important;
}

.action-group-name {
  color: #666;
  width: 50px;
}

.canvas-actions {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  z-index: 2;
  display: flex;
  padding: 8px 8px 0 0;

  >.toggles {
    display: flex;
    border-radius: 5px;
    background-color: #ddd;

    >.toggle-item {
      padding: 5px 15px;
      font-size: 1.5em;
      cursor: pointer;

      &:hover {
        background-color: #ccc;
      }

      &.active {
        background-color: var(--bs-primary);
        color: #fff;
      }

      &.disabled {
        color: #999;
        cursor: not-allowed;

        &:hover {
          background-color: transparent;
        }
      }

      &:first-child {
        border-radius: 5px 0 0 5px;
      }

      &:last-child {
        border-right: none;
        border-radius: 0 5px 5px 0;
      }
    }
  }

  #toggle-measurements {
    .mode {
      position: absolute;
      left: 0;
      right: 0;
      text-align: center;
      border-radius: 0 0 5px 5px;
      margin: 0;
      height: 25px;
      padding-top: 5px;
      font-size: 12px !important;
    }

    &.active .mode {
      background-color: var(--bs-primary);
      color: #fff;
    }
  }

  >.actions {
    margin-left: auto;
    display: flex;
    border-radius: 5px;
    background-color: #ddd;

    >.action-item {
      padding: 5px 15px;
      font-size: 1.5em;
      cursor: pointer;

      &:hover {
        background-color: #ccc;
      }

      &.active {
        background-color: var(--bs-primary);
        color: #fff;
      }

      &.disabled {
        color: #999;
        cursor: not-allowed;

        &:hover {
          background-color: transparent;
        }
      }

      &:first-child {
        border-radius: 5px 0 0 5px;
      }

      &:last-child {
        border-right: none;
        border-radius: 0 5px 5px 0;
      }
    }
  }
}

.grey_letter {
  color: #999999 !important;
}

.grey_text {
  color: #666666;
}

.project-name {
  width: 350px;
}

.project-menu {
  font-size: 0.8rem;

  >.active {
    color: var(--bs-primary);
    border-bottom: 3px solid var(--bs-primary);
  }
}

.summary-item {
  padding: 8px !important;
  cursor: pointer;

  .item-name {
    color: 000;
  }

  .dimensions {
    color: #666;
    font-size: 0.9em;
  }

  &:hover,
  &.hover {
    background-color: #ddd;
  }

  &.active {
    background-color: #bfc8d0;
  }

  &.item-selected {
    background-color: #bfc8d0;
    margin: 5px !important;

    .item-selector.checked {
      visibility: visible;
    }
  }
}

.accordion-item {
  .order-item {
    padding-left: 16px !important;
  }
}

.btn-group {
  >.btn {
    font-size: 10px !important;
    padding: 6px 8px;
  }
}

.measurement-depth {
  color: #0000ff;
  border: 2px solid #0000ff;
  border-radius: 20px;
  font-size: 20px;
  padding: 0 5px;
}

.hover-item {
  .show-on-hover {
    visibility: hidden;
  }

  &:hover {
    .show-on-hover {
      visibility: visible;
    }
  }
}

.render-canvas {
  .view-mode {
    position: absolute;
    right: 0;
    top: 0;
    z-index: 2;
  }
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, "Courier New",
    monospace;
}

input::placeholder {
  color: #AAAAAA !important;
}

.row {
  margin: 0 !important;
}

.logo {
  width: 100px;
}

.group-header {
  cursor: pointer;

  &:hover {
    background-color: #dce3e8;
  }

  .accordion-button:focus {
    box-shadow: none !important;
  }

  &.active {
    background-color: #bfc8d0;
  }

  h2.group-name {
    font-size: 1em;
  }
}

.sticker-logo {
  &.boxs {
    height: 10mm;
    width: auto;
  }

  &.custom {
    height: 10mm;
    width: auto;
  }
}

.pointer {
  cursor: pointer;
}

.pointer-important {
  cursor: pointer !important;
}

.project-summary {
  .accordion-item {
    background: none !important;
  }

  .accordion-button:focus {
    box-shadow: none !important;
  }

  .accordion-body {
    padding: 0 !important;
  }

  .accordion-button {
    display: flex;
    flex-direction: row-reverse;
    column-gap: 10px;
    background-color: transparent !important;
    border-radius: initial !important;
    padding: 0 !important;
    color: inherit !important;
  }

  .accordion-button::after {
    display: none;
    margin: 0;
  }

  .accordion-button::before {
    flex-shrink: 0;
    width: var(--bs-accordion-btn-icon-width);
    height: var(--bs-accordion-btn-icon-width);
    content: "";
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    transition: var(--bs-accordion-btn-icon-transition);
    transform: rotate(-90deg);
    margin-right: 5px;
  }

  .accordion-button:not(.collapsed)::before {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    transform: rotate(0deg);
  }
}

.active-background {
  background: #3b3b5b;
}

.inactive-background {
  background: #999 !important;
}

::-webkit-scrollbar {
  display: none;
}

.selected-thumbnail {
  border-color: #666 !important;
}

.sub-property-text {
  font-size: 12px;
  color: #000000bd;
}

.css-1u9des2-indicatorSeparator {
  display: none !important;
}

.selected-option {
  background-color: black !important;
  color: white !important;
}

.default-option:hover,
.default-option:active,
.default-option:focus-visible {
  background-color: #e2e4e7 !important;
  color: black !important;
}

.selected-option:hover,
.selected-option:focus-visible {
  background-color: #666 !important;
  color: white !important;
}

.selected-option1:hover,
.selected-option1:focus-visible {
  background-color: rgba(59, 59, 91, 0.3) !important;
  color: black !important;
}

.css-1fdsijx-ValueContainer {
  padding: 2px 8px !important;
}

.w-40 {
  width: 40%;
}

.w-60 {
  width: 60%;
}

.w-65 {
  width: 65%;
}

.w-70 {
  width: 70%;
}

.w-75px {
  width: 75px !important;
}

.nav-tabs .nav-link {
  color: #666;
}

.card {
  background-color: #fafaf5 !important;

  &.empty {
    height: 150px;
    font-size: 1.3em;
    color: #999;
    background-color: #fafafa !important;
  }
}

.property-block {
  &.disabled {
    cursor: not-allowed !important;
  }
}

.property-name {
  margin: 10px 0 0;
  font-size: 12px !important;
  font-weight: normal;
  color: #666;
}

body,
p,
input,
button {
  font-size: 12px !important;
}

@media (max-width: 578px) {

  .product-personalize-container p,
  .product-personalize-container input,
  .product-personalize-container button {
    font-size: 12px !important;
  }
}

button.selected-option {
  background-color: #2c92e6 !important;
}

button.selected-option1 {
  background-color: rgba(101, 101, 125, 0.3) !important;
}

.dropdown button.btn {
  padding: 10px;
}

.dropdown {
  >button {
    width: 30px;
    height: 30px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background: none;

    &:hover {
      background: rgba(101, 101, 125, 0.3) !important;
    }
  }

  .dropdown-menu {
    button {
      padding: 7px 20px !important;

      &:hover {
        background-color: rgba(101, 101, 125, 0.3);
      }
    }
  }
}

.btn.bg-success {
  background-color: var(--bs-primary) !important;
}

.blurred {
  opacity: 0.5;
}

.blurred-light {
  opacity: 0.2;
}

.show-update-item {
  padding-left: 1rem;
  background-color: var(--bs-primary);
  color: white;
}

.mb-8 {
  margin-bottom: 80px !important;
}

.mb-12px {
  margin-bottom: 12px !important;
}

.me-7 {
  margin-right: 70px !important;
}

.me-8px {
  margin-right: 8px !important;
}

.me-12px {
  margin-right: 12px !important;
}

.form-switch .form-check-input {
  margin: 0 !important;
  font-size: 22px !important;

  &:focus {
    box-shadow: none;
  }
}

.gap-10 {
  gap: 10px;
}

.fs-10px {
  font-size: 10px !important;
}

.fs-11px {
  font-size: 11px !important;
}

.fs-12px {
  font-size: 12px !important;
}

.fs-13px {
  font-size: 13px !important;
}

.fs-14px {
  font-size: 14px !important;
}

.fs-18px {
  font-size: 18px !important;
}

.bottom-offcanvas {
  top: unset !important;
  justify-content: flex-end !important;
  width: 100% !important;
  height: 50vh !important;
}

.catalogs-modal {
  height: 85vh;
  overflow: scroll;
}

.catalog-active {
  background-color: rgba(59, 59, 91, 0.3);
}

.cutlist-row:nth-child(odd) {
  background-color: #f2f2f2;
}

.text-secondary {
  color: #6c757d;
}

.text-AAAAAA {
  color: #aaaaaa;
}

.text-disabled, .text-subtle {
  color: #999;
}

.mt-neg-5 {
  margin-top: -5px;
}

/* .sc-jgraLO .row {
  --bs-gutter-x: 10px !important;
  --bs-gutter-y: 10px !important;
} */

.fs-ubuntu {
  font-family: "Ubuntu", sans-serif;
}

.link {
  color: #2c92e6;
}

.bg-medium-grey {
  background-color: #6c757d;
}

.bg-light-grey {
  background-color: #f3f3f3 !important;
}

.bg-DDDDDD {
  background-color: #dddddd !important;
}

.bg-EEEEEE {
  background-color: #EEEEEE !important;
}

.bg-fafafa {
  background-color: #fafafa !important;
}

.bg-brand-dark {
  background-color: var(--color-dark-1);
}

.bg-cyan-blue {
  background: #c0d4e4 !important;
}

.bg-cyan {
  background: #e3eef6 !important;
}

.text-warn-orange {
  color: #d75e08;
}

.annotation {
  position: absolute;
}

.annotation:hover {
  background-color: lightblue;
  opacity: 0.8 !important;
}

.annotation-selected {
  background-color: rgba(104, 38, 234, 0.62);
  opacity: 1;
}

.annotation-label {
  background-color: lightgray;
  border-radius: 50px;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
}

.pattern {
  background-image: repeating-linear-gradient(45deg,
      transparent,
      transparent 3px,
      #ccc 0px,
      #ccc 5px);
}

.canvas-container-centering {
  transition: left 0.5s linear, bottom 0.5s linear;
}

.selected-row {
  border: 1px #9f32cb solid;
  border-radius: 15px;
  background-color: #8d86c77d;
}

.price {
  color: var(--bs-primary);
}

.price_summary {
  .value {
    >.amount {
      color: var(--bs-primary);
    }
  }

  &.stale {
    .value {
      opacity: 0.5;
      filter: saturate(0);
    }
  }
}

.rdt_TableHead {
  font-size: 12px !important;
  font-weight: bold !important;
}

.rdt_TableHeadRow {
  background-color: #666 !important;
  color: white;

  * {
    overflow: visible !important;
  }
}

.rdt_TableRow {
  padding-top: 10px;
  padding-bottom: 10px;
}

.rdt_TableCell {
  text-align: left;
  line-height: 20px !important;
}

.rdt_Table {
  border: 1px solid rgba(0, 0, 0, 0.12);
}

.tab-border {
  border: 1px solid rgb(222, 226, 230);
  border-top: none;
}

.active-space {
  outline: 5px solid blue;
  z-index: 1;
}

.replaceable-space {
  outline: 5px solid red !important;
  z-index: 1 !important;
}

.custom-nav-pills {
  color: #666 !important;
  border-radius: 50px !important;
  margin-top: 10px;
  margin-bottom: 10px;
}

.custom-nav-pills.active {
  color: white !important;
}

.custom-nav-pills-container {
  margin-top: 15px !important;
  margin-bottom: 15px !important;
  background-color: #e5e5e5;
}

.sub-module-container {
  cursor: pointer;
}

.sub-module-container:hover {
  border: 2px solid;
  border-color: #0d6efd;
}

@keyframes blink {
  0% {
    opacity: 1;
  }

  50% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}

.disabled-div {
  pointer-events: none;
  opacity: 0.4;
}

.active-dimension {
  color: #2c92e6;
}

.active-dimension-outline {
  outline: 1px solid #2c92e6;
}

.right-pane-tabs {
  .tab-item {
    color: #666;
    font-weight: bold;

    .icon {
      height: 16px !important;
      width: 16px !important;
    }

    &.active {
      color: #2c92e6;
    }

    &:hover {
      color: #2c92e6;
    }
  }
}

.active-tab {
  background-color: #2c92e6;
  color: white;
}

.inactive-tab {
  background-color: transparent;
  color: grey;
}

.right-nav {
  width: 70px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 10px;
  background-color: lightgray;
}

.active-shutter {
  outline: 5px solid blue;
  z-index: 1;
}

.icon-outline {
  color: #fcfcfd;
}

.form-check-input:checked {
  background-color: #2c92e6 !important;
  border-color: #2c92e6 !important;
}

.primary-hover:hover {
  background-color: transparent !important;
}

.hover-underline:hover {
  text-decoration: underline;
}

.room-canvas-container {
  &:focus {
    outline: none !important;
  }
}

.wall-node {
  background-color: #eeeeee;
  border: 2px solid black;
}

.modules-container {
  box-shadow: none !important;
  padding: 0 !important;

  .modules-listing {
    padding: 0;
  }

  .module-card {
    .card-body {
      padding: 0;
      margin-top: 5px;
      flex-direction: row !important;
      flex-grow: 1;
      align-items: center;
    }
  }
}

.tooltip {
  pointer-events: none;

  .tooltip-inner {
    white-space: nowrap;
    max-width: none;
  }
}

.rect-selector {
  position: absolute;
}

.measurements {
  position: absolute;
  z-index: 5000;

  >.measurement-item {
    position: absolute;
    display: flex;
    color: blue;

    >.marker {
      display: flex;
      justify-content: space-between;
      align-items: center;

      >.line {
        flex-grow: 1;
        background: blue;
      }

      >.arrow {
        width: 10px;
        height: 10px;

        &.down {
          transform: rotate(180deg);
        }

        &.left {
          transform: rotate(-90deg);
        }

        &.right {
          transform: rotate(90deg);
        }
      }
    }

    >.text {
      flex-grow: 1;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 20px;
    }

    &.height {
      width: 40px;

      >.text {
        writing-mode: vertical-rl;
        transform: rotate(180deg);
      }

      >.marker {
        width: 20px;
        flex-direction: column;

        >.line {
          width: 2px;
        }
      }

      &.flipped {
        flex-direction: row-reverse;
      }
    }

    &.width {
      height: 40px;
      flex-direction: column-reverse;

      >.marker {
        height: 20px;

        >.line {
          height: 2px;
        }
      }

      &.flipped {
        flex-direction: column;
      }
    }
  }
}

.tab {
  cursor: pointer;
  padding: 5px 0;
  color: black;
  font-weight: bold;
}

.tab.active {
  color: #007bff;
  border-bottom: 2px solid #007bff;
}

.hover-border {
  position: absolute;
  z-index: 5001;
  pointer-events: none;
}

.selection-borders {
  position: absolute;
  z-index: 5002;
  pointer-events: none;

  >.selection {
    position: absolute;
  }
}

.danger-on-hover:hover {
  color: #dc3545 !important;
}

.css-1dimb5e-singleValue {
  height: 25px;
  display: flex;
  align-items: center;
  font-size: 11px !important;
}

.compact-select {
  .css-13cymwt-control {
    min-height: 0;
  }

  .css-1fdsijx-ValueContainer {
    padding: 2px 4px !important;

    .css-qbdosj-Input {
      margin: 0 !important;
    }

    .css-1dimb5e-singleValue {
      height: 20px !important;
      font-size: 10px !important;
    }
  }
}

.pricing-table-container {
  border: 1px solid #283039;
  box-shadow: 4px 4px 4px 0px #cccccc;
  border-radius: 8px;
  background-color: white;
}

.pricing-table {
  border-collapse: collapse;
}

.pricing-table thead {
  background-color: #283039;
  color: white;
}

.pricing-table th {
  padding: 12px 20px;
  text-align: left;
}

.pricing-table td {
  padding: 8px 12px;
  text-align: left;
}

.pricing-table tbody tr:hover {
  background-color: #bfc8d099;
}

.pricing-table .unit {
  color: #999999;
}

.details-popup {
  width: max-content;
  padding-block: 12px;
  background: white;
  border-radius: 8px;
  z-index: 1000;
  border: 1px solid #283039;
  box-shadow: 4px 4px 4px 0px #aaaaaa;
}

.subtle-gray {
  color: #aaa;
}

.less-subtle-gray {
  color: #888;
}

.toggle-container {
  background-color: #ddd;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 3px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.toggle-button {
  padding: 8px 12px;
  color: #6b7280;
  cursor: pointer;
  border-radius: 6px;
  font-weight: bold;
}

.toggle-button.active {
  background-color: #3b82f6;
  color: white;
}

.flex {
  display: flex;
}

.h-3-em {
  height: 3em;
}

.cutlist_table {
  tr.invalid {
    td {
      background: var(--bs-danger);
      color: #fff;
    }
  }
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input[type="number"] {
  -moz-appearance: textfield;
}

.dimension.form-control.is-invalid,
.was-validated .dimension.form-control:invalid {
  background: none !important;
  padding-right: 4px !important;
  border: 2px solid red !important;
}

.opacity-25 {
  opacity: 0.25;
}

.not-allowed-cursor {
  cursor: not-allowed;
}

.order-summary {
  .accordion-item {
    background: none !important;
    border: 0;
  }

  .accordion-button:focus {
    box-shadow: none !important;
  }

  .accordion,
  .accordion-body {
    display: flex;
    flex-direction: column;
    row-gap: 12px;
  }

  .accordion-body {
    padding: 12px 0 0 24px;
  }

  .accordion-button {
    background-color: transparent !important;
    border-radius: initial !important;
    padding: 0 !important;
    font-size: 14px !important;
  }

  .accordion-button::before {
    background-repeat: no-repeat;
    width: 16px;
    height: 16px;
    content: "";
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    transition: var(--bs-accordion-btn-icon-transition);
    transform: rotate(-90deg);
  }

  .accordion-button::after {
    display: none;
  }

  .accordion-button:not(.collapsed) {
    color: black;
    box-shadow: none;
  }

  .accordion-button:not(.collapsed)::before {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    transform: rotate(0deg);
    margin-right: 5px;
    margin-left: -5px;
    height: 10px;
  }

  .dropdown {
    .order-download:hover {
      background: none !important;
    }

    .dropdown-menu {
      min-width: 6rem;
      font-size: 12px;
    }

    .dropdown-menu button {
      padding: 4px 12px !important;
    }

    .dropdown-item:hover {
      background-color: #eeeeee;
    }
  }
}

.project-header {
  .dropdown {
    height: 100%;
    border-left: 1px solid #4f5f71;
    margin-left: 16px;
  }

  .dropdown:hover {
    background-color: #4f5f71;
  }

  .dropdown button.btn {
    width: fit-content;
    height: 100%;
    padding-inline: 16px;
  }

  .dropdown-menu {
    background-color: #283039;
    box-shadow: 0px 0px 4px 0px #999999;
  }

  .dropdown-menu button:hover {
    background-color: #4f5f71;
    color: white;
  }

  .align-objects:hover {
    color: #2c92e6 !important;
    border-color: #2c92e6 !important;
  }

  .dropdown-item {
    color: white;
  }

  .dropdown-item.disabled {
    color: gray;
    pointer-events: auto;
    cursor: not-allowed;
  }

  .dropdown-item.disabled:hover {
    color: gray;
    background: transparent;
  }
}

.clear-icon:hover svg path {
  stroke: #2c92e6;
}

.product-type {
  font-size: 1rem !important;
}

@media (max-width: 576px) {
  .product-type {
    font-size: 0.75rem !important;
  }
}

.copied-text {
  position: absolute;
  right: 0;
  top: 0;
  background: var(--bs-yellow);
  padding: 2px 5px;
  border-radius: 0 0 0 10px;
  border-left: 1px solid #ccc;
  border-bottom: 1px solid #ccc;
}

.properties-tab {
  input[type="text"] {
    font-size: 11px !important;
  }

  .accordion-item {
    background: none !important;
    border: 0;

    &.padded {
      .accordion-header {
        .accordion-button {
          padding: 8px !important;

          &:hover {
            background: #e5e5e5 !important;
          }
        }
      }

      .accordion-body {
        padding: 1rem !important;
        padding-top: 0.5em !important;
      }
    }
  }

  .accordion-button {
    background-color: transparent !important;
    border-radius: initial !important;
    padding: 0 !important;
    font-size: 14px !important;
    text-transform: capitalize;
  }

  .accordion-button::before {
    background-repeat: no-repeat;
    width: 16px;
    height: 16px;
    content: "";
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
    transition: var(--bs-accordion-btn-icon-transition);
    transform: rotate(-90deg);
  }

  .accordion-button::after {
    display: none;
  }

  .accordion-button:not(.collapsed) {
    color: black;
    box-shadow: none;
  }

  .accordion-button:not(.collapsed)::before {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
    transform: rotate(0deg);
    margin-right: 5px;
    margin-left: -5px;
    height: 10px;
  }

  .accordion-button:focus {
    box-shadow: none !important;
  }

  .accordion-body {
    display: flex;
    flex-direction: column;
    row-gap: 12px;
    padding: 12px 0 0 0;
  }
}

.info-header {
  background-color: #bfc8d0;
  display: flex !important;
  justify-content: space-between;
  align-items: center;
  border-bottom: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
  padding-top: 0.5rem !important;
  padding-bottom: 0.5rem !important;
  padding-right: 1rem !important;
  padding-left: 1rem !important;
}

.properties-tab .grooves_section .accordion-item {
  .accordion-body {
    padding: 0 !important;
    row-gap: 0px;
  }
}

.icon-hover {
  padding: 6px;
  color: #333333;
  font-size: 14px;
}

.icon-hover:hover {
  border-radius: 4px;
  background-color: #d9d9d9;
}

.unused_color_text {
  position: absolute;
  top: 50%;
  margin-top: -10px;
  height: 20px;
  padding-top: 2px;
  background: black;
  opacity: 0.5;
  width: 100%;
  color: white;
  text-align: center;
}

.yellow-color {
  color: #ffa600;
}

.show-overflow {
  overflow: visible !important;
}

.mb-12px {
  margin-bottom: 12px !important;
}

.new-project-summary {
  .accordion-item {
    background: none !important;
  }

  .accordion-body {
    padding: 0 !important;
  }

  .accordion-button {
    background-color: transparent !important;
    padding: 0 !important;
    color: inherit !important;
  }

  .accordion-button:focus {
    box-shadow: none !important;
  }

  .accordion-button::after,
  .accordion-button::before {
    display: none;
    margin: 0;
  }

  .accordion-header {
    width: 100%;
  }
}

.active-item {
  background: #c0d4e4 !important;
}

@keyframes smooth-appear {
  from {
    transform: translateY(100%);
    opacity: 0;
  }

  to {
    transform: translateY(0);
    opacity: 1;
  }
}

@keyframes smooth-hide {
  from {
    transform: translateY(0);
    opacity: 1;
  }

  to {
    transform: translateY(100%);
    opacity: 0;
  }
}

.overlay {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 40vh;
  min-height: 330px;
  background-color: #eeeeee;
  box-shadow: 0px -4px 4px 0px rgba(0, 0, 0, 0.2);
  z-index: 1000;
  display: flex;
  flex-direction: column;
  border: 1px solid #999999;
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
  overflow: hidden;
}

.overlay.show {
  animation: smooth-appear 0.3s ease forwards;
}

.overlay.hide {
  animation: smooth-hide 0.3s ease forwards;
}

.left-section {
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 1 1;
  /* background-color: white; */
}

.right-section {
  display: flex;
  flex-direction: column;
  width: 40%;
  min-width: 150px;
  font-size: 10px;

  .form-wrapper {
    border-radius: 15px;
  }
}

.content-container {
  flex: 1 1;
  overflow-y: auto;
  padding: 10px;
}

.footer-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 0 20px;
  background-color: #283045;
  border-top: 1px solid #999999;
  flex-shrink: 0;
}

.footer-text {
  color: #aaaaaa;
  height: 50px;
  display: flex;
  align-items: center;
}

.footer-button {
  background-color: #ff344c;
  color: white;
  padding: 4px;
  text-align: center;
  border-radius: 5px;
  min-width: 120px;
  cursor: pointer;
}

.togle-container {
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 10px;
  color: #999999;
  margin-top: 5px;
}

.bg-body-dark {
  background-color: #dddddd;
}

.modal-popup {
  position: relative;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
}

.capital-letter {
  p::first-letter {
    text-transform: capitalize;
  }

  div::first-letter {
    text-transform: capitalize;
  }
}

.direction-filler {
  border-bottom: #dddddd solid 1px;
}

.direction-item {
  padding-bottom: 7px;
  font-weight: bold;
}

.w-100px {
  width: 100px;
}

.w-50px {
  width: 50px !important;
}

.bg-body-light-grey {
  background-color: #f5f5f5 !important;
}

.shadow-right {
  box-shadow: 3px 0px 3px #ddd;
}

.done-button {
  border: 1px solid #aaaaaa;
  border-radius: 5px;
  background-color: #ffffff;
  padding-top: 7px;
  padding-bottom: 7px;
  padding-left: 20px;
  padding-right: 20px;
  cursor: pointer;
  width: fit-content;
  color: #666666;
  font-weight: 500;
}

.list-summary-select {
  width: 250px !important;
}

.min-height-38px {
  min-height: 38px;
}

.transform-x-negative-half {
  transform: translate(-50%, 0px);
}

.loader-grey {
  background-color: #cccccc !important;
}

.h-10px {
  height: 10px;
}

.highlight_property {
  background: #fff5cc;
}

.status-active {
  .dimension {
    background: #fff;
  }
}

.bg-pink {
  background-color: #fdebeb;
}

.border-danger {
  border-color: #dc3545 !important;
}

.icon-red {
  color: #dc3545;
}

.icon-black {
  color: black;
}

.icon-white {
  color: wheat;
}

/* Custom filter pill styles */
.reports-filter-btn {
  border: 1px solid #ccc;
  background-color: #f8f9fa;
  color: #000;
  font-size: 0.85rem;
  padding: 2px 10px;
  border-radius: 0.25rem;
  cursor: pointer;

  &:hover {
    background-color: #e2e6ea;
  }
}

.reports-filter-active {
  background-color: #343a40;
  color: #fff;

  &:hover {
    background-color: #343a40;
  }
}

/* Custom table header */
.reports-custom-table-header th {
  color: #fff !important;
  font-weight: bold;
}

@keyframes highlightFade {
  0% {
    background-color: #ffe58a;
    /* Start: light yellow */
  }

  100% {
    background-color: transparent;
    /* End: transparent */
  }
}

.highlighted {
  animation: highlightFade 2s ease forwards;
}

.fs-35px {
  font-size: 35px;
}

.fs-28px {
  font-size: 28px;
}

.fs-20px {
  font-size: 20px;
}

.fs-16px {
  font-size: 16px !important;
}

@media (min-width: 768px) {
  .fs-md-50px {
    font-size: 50px;
  }

  .fs-md-30px {
    font-size: 30px;
  }

  .fs-md-20px {
    font-size: 20px !important;
  }
}

.overriden-text-input::placeholder {
  color: black !important;
}

.placeholder-grey::placeholder {
  color: #AAAAAA !important;
}

.preview-btn {
  width: 20%;
  z-index: 1000;
}

.overriden-focus-text {
  color: black;
}

.placeholder-grey-text {
  color: #aaaaaa;
}

.expo-toggle-switch {
  width: 70px;
  height: 26px;
}

.expo-toggle-switch .slider {
  background-color: #ccc;
  border-radius: 34px;
  transition: 0.4s;
  padding-left: 20px;
}

.expo-toggle-switch .slider:before {
  content: "";
  position: absolute;
  height: 18px;
  width: 18px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  border-radius: 50%;
  transition: 0.4s;
}

.expo-toggle-switch input:checked + .slider {
  background-color: #2196f3;
  padding-left: 20px;
  padding-right: 30px;
}

.expo-toggle-switch input:checked + .slider:before {
  transform: translateX(44px);
}

.expo-toggle-switch .slider span {
  position: relative;
  transition: 0.4s;
  transform: translateX(1px);
  font-size: 12px;
}

.expo-toggle-switch input:checked + .slider span {
  transform: translateX(-7px);
}

.hover-bg:hover {
  background-color: #f5f5f5;
}
.context-menu-item {
  padding: 8px 16px;
  cursor: pointer;
}

.context-menu-item:hover {
  background-color: #f0f0f0;
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,SAAS;EACT;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;EAClC,2CAA2C;EAC3C,yBAAyB;EACzB,qBAAqB;EACrB,8BAA8B;EAC9B,uBAAuB;EACvB,kBAAkB;EAClB,oBAAoB;EACpB,0BAA0B;AAC5B;;AAEA;EACE,oBAAoB;EACpB,0BAA0B;AAC5B;;AAEA;EACE,6BAA6B;EAC7B,gCAAgC;EAChC,uCAAuC;AACzC;;AAEA;EACE;IACE,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,8BAA8B;EAChC;;EAEA;IACE,6BAA6B;IAC7B,UAAU;;IAEV;MACE,gBAAgB;MAChB,UAAU;;MAEV,mBAAmB;;MAEnB;QACE,kBAAkB;QAClB,wBAAwB;MAC1B;;MAEA;QACE,kBAAkB;;QAElB;UACE,cAAc;;UAEd;YACE,YAAY;UACd;QACF;;QAEA;UACE,aAAa;UACb,kBAAkB;UAClB,iBAAiB;QACnB;;QAEA;UACE,gBAAgB;UAChB,iBAAiB;QACnB;MACF;;MAEA;QACE,8BAA8B;QAC9B,sBAAsB;QACtB,kBAAkB;QAClB,eAAe;;QAEf;UACE,gBAAgB;UAChB,UAAU;UACV,SAAS;;UAET;YACE,kBAAkB;YAClB,6BAA6B;;YAE7B;cACE,gBAAgB;cAChB,iBAAiB;YACnB;;YAEA;cACE,cAAc;cACd,WAAW;YACb;UACF;QACF;MACF;;MAEA;QACE;UACE,gBAAgB;QAClB;;QAEA;UACE,aAAa;QACf;MACF;IACF;;IAEA;MACE,mBAAmB;;MAEnB;QACE;UACE,iCAAiC;UACjC,mBAAmB;QACrB;MACF;;MAEA;QACE,kBAAkB;QAClB,gCAAgC;QAChC,WAAW;;QAEX;UACE,gBAAgB;QAClB;;QAEA;UACE,oBAAoB;UACpB,WAAW;QACb;MACF;IACF;;IAEA;MACE,eAAe;;MAEf;QACE,2BAA2B;QAC3B,iBAAiB;MACnB;IACF;EACF;AACF;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,6BAA6B;EAC7B,4BAA4B;EAC5B,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,6BAA6B;EAC7B,2BAA2B;EAC3B,UAAU;;EAEV;IACE,YAAY;EACd;AACF;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,UAAU;EACV,aAAa;EACb,oBAAoB;;EAEpB;IACE,aAAa;IACb,kBAAkB;IAClB,sBAAsB;;IAEtB;MACE,iBAAiB;MACjB,gBAAgB;MAChB,eAAe;;MAEf;QACE,sBAAsB;MACxB;;MAEA;QACE,mCAAmC;QACnC,WAAW;MACb;;MAEA;QACE,WAAW;QACX,mBAAmB;;QAEnB;UACE,6BAA6B;QAC/B;MACF;;MAEA;QACE,0BAA0B;MAC5B;;MAEA;QACE,kBAAkB;QAClB,0BAA0B;MAC5B;IACF;EACF;;EAEA;IACE;MACE,kBAAkB;MAClB,OAAO;MACP,QAAQ;MACR,kBAAkB;MAClB,0BAA0B;MAC1B,SAAS;MACT,YAAY;MACZ,gBAAgB;MAChB,0BAA0B;IAC5B;;IAEA;MACE,mCAAmC;MACnC,WAAW;IACb;EACF;;EAEA;IACE,iBAAiB;IACjB,aAAa;IACb,kBAAkB;IAClB,sBAAsB;;IAEtB;MACE,iBAAiB;MACjB,gBAAgB;MAChB,eAAe;;MAEf;QACE,sBAAsB;MACxB;;MAEA;QACE,mCAAmC;QACnC,WAAW;MACb;;MAEA;QACE,WAAW;QACX,mBAAmB;;QAEnB;UACE,6BAA6B;QAC/B;MACF;;MAEA;QACE,0BAA0B;MAC5B;;MAEA;QACE,kBAAkB;QAClB,0BAA0B;MAC5B;IACF;EACF;AACF;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,iBAAiB;;EAEjB;IACE,wBAAwB;IACxB,0CAA0C;EAC5C;AACF;;AAEA;EACE,uBAAuB;EACvB,eAAe;;EAEf;IACE,UAAU;EACZ;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB;;EAEA;;IAEE,sBAAsB;EACxB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;IACzB,sBAAsB;;IAEtB;MACE,mBAAmB;IACrB;EACF;AACF;;AAEA;EACE;IACE,6BAA6B;EAC/B;AACF;;AAEA;EACE;IACE,0BAA0B;IAC1B,gBAAgB;EAClB;AACF;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE;MACE,mBAAmB;IACrB;EACF;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,QAAQ;IACR,MAAM;IACN,UAAU;EACZ;AACF;;AAEA;EACE;aACW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;;EAEf;IACE,yBAAyB;EAC3B;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,cAAc;EAChB;AACF;;AAEA;EACE;IACE,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,YAAY;IACZ,WAAW;EACb;AACF;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE;IACE,2BAA2B;EAC7B;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,aAAa;IACb,2BAA2B;IAC3B,gBAAgB;IAChB,wCAAwC;IACxC,iCAAiC;IACjC,qBAAqB;IACrB,yBAAyB;EAC3B;;EAEA;IACE,aAAa;IACb,SAAS;EACX;;EAEA;IACE,cAAc;IACd,yCAAyC;IACzC,0CAA0C;IAC1C,WAAW;IACX,yDAAqR;IACrR,mDAAmD;IACnD,yBAAyB;IACzB,iBAAiB;EACnB;;EAEA;IACE,yDAAqR;IACrR,uBAAuB;EACzB;AACF;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,kCAAkC;EAClC,uBAAuB;AACzB;;AAEA;;;EAGE,oCAAoC;EACpC,uBAAuB;AACzB;;AAEA;;EAEE,iCAAiC;EACjC,uBAAuB;AACzB;;AAEA;;EAEE,kDAAkD;EAClD,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,oCAAoC;;EAEpC;IACE,aAAa;IACb,gBAAgB;IAChB,WAAW;IACX,oCAAoC;EACtC;AACF;;AAEA;EACE;IACE,8BAA8B;EAChC;AACF;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,mBAAmB;EACnB,WAAW;AACb;;AAEA;;;;EAIE,0BAA0B;AAC5B;;AAEA;;EAEE;;;IAGE,0BAA0B;EAC5B;AACF;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,WAAW;IACX,YAAY;IACZ,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;;IAEhB;MACE,+CAA+C;IACjD;EACF;;EAEA;IACE;MACE,4BAA4B;;MAE5B;QACE,0CAA0C;MAC5C;IACF;EACF;AACF;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,mCAAmC;EACnC,YAAY;AACd;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,oBAAoB;EACpB,0BAA0B;;EAE1B;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;EACrB,oCAAoC;EACpC,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;;GAGG;;AAEH;EACE,iCAAiC;AACnC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,uBAAuB;AACzB;;AAEA;EACE,0CAA0C;EAC1C,UAAU;AACZ;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE;;;;eAIa;AACf;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE;IACE;MACE,wBAAwB;IAC1B;EACF;;EAEA;IACE;MACE,YAAY;MACZ,mBAAmB;IACrB;EACF;AACF;;AAEA;EACE,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA;EACE,iCAAiC;EACjC,YAAY;;EAEZ;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,UAAU;AACZ;;AAEA;EACE,iCAAiC;EACjC,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;EACtB,8BAA8B;EAC9B,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;EAC3B,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE;IACE,WAAW;IACX,iBAAiB;;IAEjB;MACE,uBAAuB;MACvB,sBAAsB;IACxB;;IAEA;MACE,cAAc;IAChB;;IAEA;MACE,cAAc;IAChB;EACF;AACF;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,6BAA6B;EAC7B,WAAW;AACb;;AAEA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;EACvB,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;EAC3B,qBAAqB;;EAErB;IACE,UAAU;EACZ;;EAEA;IACE;MACE,UAAU;MACV,eAAe;MACf,8BAA8B;MAC9B,YAAY;MACZ,mBAAmB;IACrB;EACF;AACF;;AAEA;EACE,oBAAoB;;EAEpB;IACE,mBAAmB;IACnB,eAAe;EACjB;AACF;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,aAAa;;EAEb;IACE,kBAAkB;IAClB,aAAa;IACb,WAAW;;IAEX;MACE,aAAa;MACb,8BAA8B;MAC9B,mBAAmB;;MAEnB;QACE,YAAY;QACZ,gBAAgB;MAClB;;MAEA;QACE,WAAW;QACX,YAAY;;QAEZ;UACE,yBAAyB;QAC3B;;QAEA;UACE,yBAAyB;QAC3B;;QAEA;UACE,wBAAwB;QAC1B;MACF;IACF;;IAEA;MACE,YAAY;MACZ,YAAY;MACZ,aAAa;MACb,mBAAmB;MACnB,uBAAuB;MACvB,eAAe;IACjB;;IAEA;MACE,WAAW;;MAEX;QACE,yBAAyB;QACzB,yBAAyB;MAC3B;;MAEA;QACE,WAAW;QACX,sBAAsB;;QAEtB;UACE,UAAU;QACZ;MACF;;MAEA;QACE,2BAA2B;MAC7B;IACF;;IAEA;MACE,YAAY;MACZ,8BAA8B;;MAE9B;QACE,YAAY;;QAEZ;UACE,WAAW;QACb;MACF;;MAEA;QACE,sBAAsB;MACxB;IACF;EACF;AACF;;AAEA;EACE,eAAe;EACf,cAAc;EACd,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,oBAAoB;;EAEpB;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,2BAA2B;;IAE3B;MACE,oBAAoB;IACtB;;IAEA;MACE,uBAAuB;MACvB,0BAA0B;IAC5B;EACF;AACF;;AAEA;EACE,yBAAyB;EACzB,mCAAmC;EACnC,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,yBAAyB;EACzB,mCAAmC;AACrC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,wCAAwC;AAC1C;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;AACb;;AAEA;EACE;IACE;MACE,4BAA4B;MAC5B,WAAW;IACb;EACF;AACF;;AAEA;;EAEE,wBAAwB;EACxB,SAAS;AACX;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;;EAEE,2BAA2B;EAC3B,6BAA6B;EAC7B,gCAAgC;AAClC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,2BAA2B;IAC3B,SAAS;EACX;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;;IAEE,aAAa;IACb,sBAAsB;IACtB,aAAa;EACf;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,wCAAwC;IACxC,iCAAiC;IACjC,qBAAqB;IACrB,0BAA0B;EAC5B;;EAEA;IACE,4BAA4B;IAC5B,WAAW;IACX,YAAY;IACZ,WAAW;IACX,yDAAmR;IACnR,mDAAmD;IACnD,yBAAyB;EAC3B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,yDAAmR;IACnR,uBAAuB;IACvB,iBAAiB;IACjB,iBAAiB;IACjB,YAAY;EACd;;EAEA;IACE;MACE,2BAA2B;IAC7B;;IAEA;MACE,eAAe;MACf,eAAe;IACjB;;IAEA;MACE,4BAA4B;IAC9B;;IAEA;MACE,yBAAyB;IAC3B;EACF;AACF;;AAEA;EACE;IACE,YAAY;IACZ,8BAA8B;IAC9B,iBAAiB;EACnB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,oBAAoB;EACtB;;EAEA;IACE,yBAAyB;IACzB,mCAAmC;EACrC;;EAEA;IACE,yBAAyB;IACzB,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,gCAAgC;EAClC;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,WAAW;IACX,oBAAoB;IACpB,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,uBAAuB;EACzB;AACF;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE;IACE,6BAA6B;EAC/B;AACF;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,MAAM;EACN,4BAA4B;EAC5B,gBAAgB;EAChB,yBAAyB;EACzB,2BAA2B;EAC3B,6BAA6B;AAC/B;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,2BAA2B;IAC3B,SAAS;;IAET;MACE;QACE;UACE,uBAAuB;;UAEvB;YACE,8BAA8B;UAChC;QACF;MACF;;MAEA;QACE,wBAAwB;QACxB,6BAA6B;MAC/B;IACF;EACF;;EAEA;IACE,wCAAwC;IACxC,iCAAiC;IACjC,qBAAqB;IACrB,0BAA0B;IAC1B,0BAA0B;EAC5B;;EAEA;IACE,4BAA4B;IAC5B,WAAW;IACX,YAAY;IACZ,WAAW;IACX,yDAA4S;IAC5S,mDAAmD;IACnD,yBAAyB;EAC3B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,yDAA4S;IAC5S,uBAAuB;IACvB,iBAAiB;IACjB,iBAAiB;IACjB,YAAY;EACd;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,aAAa;IACb,mBAAmB;EACrB;AACF;;AAEA;EACE,yBAAyB;EACzB,wBAAwB;EACxB,8BAA8B;EAC9B,mBAAmB;EACnB,8FAA8F;EAC9F,8BAA8B;EAC9B,iCAAiC;EACjC,8BAA8B;EAC9B,6BAA6B;AAC/B;;AAEA;EACE;IACE,qBAAqB;IACrB,YAAY;EACd;AACF;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE;IACE,2BAA2B;EAC7B;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,wCAAwC;IACxC,qBAAqB;IACrB,yBAAyB;EAC3B;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;;IAEE,aAAa;IACb,SAAS;EACX;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE;IACE,2BAA2B;IAC3B,UAAU;EACZ;;EAEA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA;EACE;IACE,wBAAwB;IACxB,UAAU;EACZ;;EAEA;IACE,2BAA2B;IAC3B,UAAU;EACZ;AACF;;AAEA;EACE,eAAe;EACf,SAAS;EACT,OAAO;EACP,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,yBAAyB;EACzB,+CAA+C;EAC/C,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,4BAA4B;EAC5B,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAO;EACP,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,UAAU;EACV,gBAAgB;EAChB,eAAe;;EAEf;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,yBAAyB;EACzB,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,WAAW;EACX,YAAY;EACZ,oCAAoC;AACtC;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA,8BAA8B;AAC9B;EACE,sBAAsB;EACtB,yBAAyB;EACzB,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;EACtB,eAAe;;EAEf;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,yBAAyB;EACzB,WAAW;;EAEX;IACE,yBAAyB;EAC3B;AACF;;AAEA,wBAAwB;AACxB;EACE,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE;IACE,yBAAyB;IACzB,wBAAwB;EAC1B;;EAEA;IACE,6BAA6B;IAC7B,qBAAqB;EACvB;AACF;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,SAAS;EACT,WAAW;EACX,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":["html {\n  height: 100%;\n}\n\nbody {\n  height: 100%;\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\",\n    \"Ubuntu\", \"Cantarell\", \"Fira Sans\", \"Droid Sans\", \"Helvetica Neue\",\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  font-family: \"Inter\", sans-serif !important;\n  font-optical-sizing: auto;\n  --bs-primary: #1b8eed;\n  --bs-primary-rgb: 27, 142, 237;\n  --color-dark-1: #283045;\n  --bg-light-1: #eee;\n  --border-light: #ddd;\n  --bs-border-color: #d5d5d5;\n}\n\n.btn-primary {\n  --bs-btn-bg: #1b8eed;\n  --bs-btn-hover-bg: #3299ef;\n}\n\n.btn:disabled {\n  --bs-btn-disabled-bg: #DDDDDD;\n  --bs-btn-disabled-color: #AAAAAA;\n  --bs-btn-disabled-border-color: #AAAAAA;\n}\n\n#home_page {\n  .app-header {\n    padding-left: 24px;\n    padding-right: 24px;\n    position: relative;\n    background: rgba(0, 0, 0, 0.5);\n  }\n\n  .home-content {\n    position: relative !important;\n    z-index: 1;\n\n    .hero-wrapper {\n      margin-top: 70px;\n      z-index: 1;\n\n      align-items: center;\n\n      .hero-message {\n        text-align: center;\n        margin: 6em 0 !important;\n      }\n\n      .product {\n        text-align: center;\n\n        .l1 {\n          font-size: 2em;\n\n          img {\n            height: 32px;\n          }\n        }\n\n        .l2 {\n          margin: 5px 0;\n          font-style: italic;\n          font-size: 1.25em;\n        }\n\n        .l3 {\n          font-size: 1.5em;\n          font-weight: bold;\n        }\n      }\n\n      .hero-points {\n        background: rgba(0, 0, 0, 0.5);\n        border: 1px solid #666;\n        border-radius: 5px;\n        margin-top: 3em;\n\n        ul {\n          list-style: none;\n          padding: 0;\n          margin: 0;\n\n          li {\n            padding: 10px 10px;\n            border-bottom: 1px solid #666;\n\n            .main {\n              font-size: 1.5em;\n              font-weight: bold;\n            }\n\n            .sub {\n              font-size: 1em;\n              color: #999;\n            }\n          }\n        }\n      }\n\n      @media (min-width: 768px) {\n        .hero-message {\n          text-align: left;\n        }\n\n        hr {\n          display: none;\n        }\n      }\n    }\n\n    .benefits {\n      background: #283039;\n\n      .list {\n        @media (min-width: 720px) {\n          flex-direction: column !important;\n          align-items: center;\n        }\n      }\n\n      .item {\n        border-radius: 5px;\n        border-color: #44515f !important;\n        color: #fff;\n\n        h4 {\n          font-size: 1.5em;\n        }\n\n        p {\n          margin: 0 !important;\n          color: #ccc;\n        }\n      }\n    }\n\n    .cta {\n      padding: 50px 0;\n\n      .primary {\n        font-size: 1.5em !important;\n        font-weight: bold;\n      }\n    }\n  }\n}\n\n.fh {\n  height: 100vh;\n  overflow: scroll;\n}\n\n.project-header {\n  min-height: 50px;\n}\n\n.App>div {\n  height: 100%;\n}\n\n.left-pane {\n  width: 250px;\n  min-width: 250px;\n  background: var(--bg-light-1);\n  border-right: 1px solid #ddd;\n  z-index: 1;\n}\n\n.right-pane {\n  width: 300px;\n  min-width: 300px;\n  background: var(--bg-light-1);\n  border-left: 1px solid #ddd;\n  z-index: 1;\n\n  &.wide {\n    width: 500px;\n  }\n}\n\n.border-bottom {\n  border-bottom: 1px solid #ddd !important;\n}\n\n.action-group-name {\n  color: #666;\n  width: 50px;\n}\n\n.canvas-actions {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  z-index: 2;\n  display: flex;\n  padding: 8px 8px 0 0;\n\n  >.toggles {\n    display: flex;\n    border-radius: 5px;\n    background-color: #ddd;\n\n    >.toggle-item {\n      padding: 5px 15px;\n      font-size: 1.5em;\n      cursor: pointer;\n\n      &:hover {\n        background-color: #ccc;\n      }\n\n      &.active {\n        background-color: var(--bs-primary);\n        color: #fff;\n      }\n\n      &.disabled {\n        color: #999;\n        cursor: not-allowed;\n\n        &:hover {\n          background-color: transparent;\n        }\n      }\n\n      &:first-child {\n        border-radius: 5px 0 0 5px;\n      }\n\n      &:last-child {\n        border-right: none;\n        border-radius: 0 5px 5px 0;\n      }\n    }\n  }\n\n  #toggle-measurements {\n    .mode {\n      position: absolute;\n      left: 0;\n      right: 0;\n      text-align: center;\n      border-radius: 0 0 5px 5px;\n      margin: 0;\n      height: 25px;\n      padding-top: 5px;\n      font-size: 12px !important;\n    }\n\n    &.active .mode {\n      background-color: var(--bs-primary);\n      color: #fff;\n    }\n  }\n\n  >.actions {\n    margin-left: auto;\n    display: flex;\n    border-radius: 5px;\n    background-color: #ddd;\n\n    >.action-item {\n      padding: 5px 15px;\n      font-size: 1.5em;\n      cursor: pointer;\n\n      &:hover {\n        background-color: #ccc;\n      }\n\n      &.active {\n        background-color: var(--bs-primary);\n        color: #fff;\n      }\n\n      &.disabled {\n        color: #999;\n        cursor: not-allowed;\n\n        &:hover {\n          background-color: transparent;\n        }\n      }\n\n      &:first-child {\n        border-radius: 5px 0 0 5px;\n      }\n\n      &:last-child {\n        border-right: none;\n        border-radius: 0 5px 5px 0;\n      }\n    }\n  }\n}\n\n.grey_letter {\n  color: #999999 !important;\n}\n\n.grey_text {\n  color: #666666;\n}\n\n.project-name {\n  width: 350px;\n}\n\n.project-menu {\n  font-size: 0.8rem;\n\n  >.active {\n    color: var(--bs-primary);\n    border-bottom: 3px solid var(--bs-primary);\n  }\n}\n\n.summary-item {\n  padding: 8px !important;\n  cursor: pointer;\n\n  .item-name {\n    color: 000;\n  }\n\n  .dimensions {\n    color: #666;\n    font-size: 0.9em;\n  }\n\n  &:hover,\n  &.hover {\n    background-color: #ddd;\n  }\n\n  &.active {\n    background-color: #bfc8d0;\n  }\n\n  &.item-selected {\n    background-color: #bfc8d0;\n    margin: 5px !important;\n\n    .item-selector.checked {\n      visibility: visible;\n    }\n  }\n}\n\n.accordion-item {\n  .order-item {\n    padding-left: 16px !important;\n  }\n}\n\n.btn-group {\n  >.btn {\n    font-size: 10px !important;\n    padding: 6px 8px;\n  }\n}\n\n.measurement-depth {\n  color: #0000ff;\n  border: 2px solid #0000ff;\n  border-radius: 20px;\n  font-size: 20px;\n  padding: 0 5px;\n}\n\n.hover-item {\n  .show-on-hover {\n    visibility: hidden;\n  }\n\n  &:hover {\n    .show-on-hover {\n      visibility: visible;\n    }\n  }\n}\n\n.render-canvas {\n  .view-mode {\n    position: absolute;\n    right: 0;\n    top: 0;\n    z-index: 2;\n  }\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, \"Courier New\",\n    monospace;\n}\n\ninput::placeholder {\n  color: #AAAAAA !important;\n}\n\n.row {\n  margin: 0 !important;\n}\n\n.logo {\n  width: 100px;\n}\n\n.group-header {\n  cursor: pointer;\n\n  &:hover {\n    background-color: #dce3e8;\n  }\n\n  .accordion-button:focus {\n    box-shadow: none !important;\n  }\n\n  &.active {\n    background-color: #bfc8d0;\n  }\n\n  h2.group-name {\n    font-size: 1em;\n  }\n}\n\n.sticker-logo {\n  &.boxs {\n    height: 10mm;\n    width: auto;\n  }\n\n  &.custom {\n    height: 10mm;\n    width: auto;\n  }\n}\n\n.pointer {\n  cursor: pointer;\n}\n\n.pointer-important {\n  cursor: pointer !important;\n}\n\n.project-summary {\n  .accordion-item {\n    background: none !important;\n  }\n\n  .accordion-button:focus {\n    box-shadow: none !important;\n  }\n\n  .accordion-body {\n    padding: 0 !important;\n  }\n\n  .accordion-button {\n    display: flex;\n    flex-direction: row-reverse;\n    column-gap: 10px;\n    background-color: transparent !important;\n    border-radius: initial !important;\n    padding: 0 !important;\n    color: inherit !important;\n  }\n\n  .accordion-button::after {\n    display: none;\n    margin: 0;\n  }\n\n  .accordion-button::before {\n    flex-shrink: 0;\n    width: var(--bs-accordion-btn-icon-width);\n    height: var(--bs-accordion-btn-icon-width);\n    content: \"\";\n    background-image: url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23000000'><path fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/></svg>\");\n    transition: var(--bs-accordion-btn-icon-transition);\n    transform: rotate(-90deg);\n    margin-right: 5px;\n  }\n\n  .accordion-button:not(.collapsed)::before {\n    background-image: url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23000000'><path fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/></svg>\");\n    transform: rotate(0deg);\n  }\n}\n\n.active-background {\n  background: #3b3b5b;\n}\n\n.inactive-background {\n  background: #999 !important;\n}\n\n::-webkit-scrollbar {\n  display: none;\n}\n\n.selected-thumbnail {\n  border-color: #666 !important;\n}\n\n.sub-property-text {\n  font-size: 12px;\n  color: #000000bd;\n}\n\n.css-1u9des2-indicatorSeparator {\n  display: none !important;\n}\n\n.selected-option {\n  background-color: black !important;\n  color: white !important;\n}\n\n.default-option:hover,\n.default-option:active,\n.default-option:focus-visible {\n  background-color: #e2e4e7 !important;\n  color: black !important;\n}\n\n.selected-option:hover,\n.selected-option:focus-visible {\n  background-color: #666 !important;\n  color: white !important;\n}\n\n.selected-option1:hover,\n.selected-option1:focus-visible {\n  background-color: rgba(59, 59, 91, 0.3) !important;\n  color: black !important;\n}\n\n.css-1fdsijx-ValueContainer {\n  padding: 2px 8px !important;\n}\n\n.w-40 {\n  width: 40%;\n}\n\n.w-60 {\n  width: 60%;\n}\n\n.w-65 {\n  width: 65%;\n}\n\n.w-70 {\n  width: 70%;\n}\n\n.w-75px {\n  width: 75px !important;\n}\n\n.nav-tabs .nav-link {\n  color: #666;\n}\n\n.card {\n  background-color: #fafaf5 !important;\n\n  &.empty {\n    height: 150px;\n    font-size: 1.3em;\n    color: #999;\n    background-color: #fafafa !important;\n  }\n}\n\n.property-block {\n  &.disabled {\n    cursor: not-allowed !important;\n  }\n}\n\n.property-name {\n  margin: 10px 0 0;\n  font-size: 12px !important;\n  font-weight: normal;\n  color: #666;\n}\n\nbody,\np,\ninput,\nbutton {\n  font-size: 12px !important;\n}\n\n@media (max-width: 578px) {\n\n  .product-personalize-container p,\n  .product-personalize-container input,\n  .product-personalize-container button {\n    font-size: 12px !important;\n  }\n}\n\nbutton.selected-option {\n  background-color: #2c92e6 !important;\n}\n\nbutton.selected-option1 {\n  background-color: rgba(101, 101, 125, 0.3) !important;\n}\n\n.dropdown button.btn {\n  padding: 10px;\n}\n\n.dropdown {\n  >button {\n    width: 30px;\n    height: 30px;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    background: none;\n\n    &:hover {\n      background: rgba(101, 101, 125, 0.3) !important;\n    }\n  }\n\n  .dropdown-menu {\n    button {\n      padding: 7px 20px !important;\n\n      &:hover {\n        background-color: rgba(101, 101, 125, 0.3);\n      }\n    }\n  }\n}\n\n.btn.bg-success {\n  background-color: var(--bs-primary) !important;\n}\n\n.blurred {\n  opacity: 0.5;\n}\n\n.blurred-light {\n  opacity: 0.2;\n}\n\n.show-update-item {\n  padding-left: 1rem;\n  background-color: var(--bs-primary);\n  color: white;\n}\n\n.mb-8 {\n  margin-bottom: 80px !important;\n}\n\n.mb-12px {\n  margin-bottom: 12px !important;\n}\n\n.me-7 {\n  margin-right: 70px !important;\n}\n\n.me-8px {\n  margin-right: 8px !important;\n}\n\n.me-12px {\n  margin-right: 12px !important;\n}\n\n.form-switch .form-check-input {\n  margin: 0 !important;\n  font-size: 22px !important;\n\n  &:focus {\n    box-shadow: none;\n  }\n}\n\n.gap-10 {\n  gap: 10px;\n}\n\n.fs-10px {\n  font-size: 10px !important;\n}\n\n.fs-11px {\n  font-size: 11px !important;\n}\n\n.fs-12px {\n  font-size: 12px !important;\n}\n\n.fs-13px {\n  font-size: 13px !important;\n}\n\n.fs-14px {\n  font-size: 14px !important;\n}\n\n.fs-18px {\n  font-size: 18px !important;\n}\n\n.bottom-offcanvas {\n  top: unset !important;\n  justify-content: flex-end !important;\n  width: 100% !important;\n  height: 50vh !important;\n}\n\n.catalogs-modal {\n  height: 85vh;\n  overflow: scroll;\n}\n\n.catalog-active {\n  background-color: rgba(59, 59, 91, 0.3);\n}\n\n.cutlist-row:nth-child(odd) {\n  background-color: #f2f2f2;\n}\n\n.text-secondary {\n  color: #6c757d;\n}\n\n.text-AAAAAA {\n  color: #aaaaaa;\n}\n\n.text-disabled, .text-subtle {\n  color: #999;\n}\n\n.mt-neg-5 {\n  margin-top: -5px;\n}\n\n/* .sc-jgraLO .row {\n  --bs-gutter-x: 10px !important;\n  --bs-gutter-y: 10px !important;\n} */\n\n.fs-ubuntu {\n  font-family: \"Ubuntu\", sans-serif;\n}\n\n.link {\n  color: #2c92e6;\n}\n\n.bg-medium-grey {\n  background-color: #6c757d;\n}\n\n.bg-light-grey {\n  background-color: #f3f3f3 !important;\n}\n\n.bg-DDDDDD {\n  background-color: #dddddd !important;\n}\n\n.bg-EEEEEE {\n  background-color: #EEEEEE !important;\n}\n\n.bg-fafafa {\n  background-color: #fafafa !important;\n}\n\n.bg-brand-dark {\n  background-color: var(--color-dark-1);\n}\n\n.bg-cyan-blue {\n  background: #c0d4e4 !important;\n}\n\n.bg-cyan {\n  background: #e3eef6 !important;\n}\n\n.text-warn-orange {\n  color: #d75e08;\n}\n\n.annotation {\n  position: absolute;\n}\n\n.annotation:hover {\n  background-color: lightblue;\n  opacity: 0.8 !important;\n}\n\n.annotation-selected {\n  background-color: rgba(104, 38, 234, 0.62);\n  opacity: 1;\n}\n\n.annotation-label {\n  background-color: lightgray;\n  border-radius: 50px;\n  width: 30px;\n  height: 30px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: bold;\n}\n\n.pattern {\n  background-image: repeating-linear-gradient(45deg,\n      transparent,\n      transparent 3px,\n      #ccc 0px,\n      #ccc 5px);\n}\n\n.canvas-container-centering {\n  transition: left 0.5s linear, bottom 0.5s linear;\n}\n\n.selected-row {\n  border: 1px #9f32cb solid;\n  border-radius: 15px;\n  background-color: #8d86c77d;\n}\n\n.price {\n  color: var(--bs-primary);\n}\n\n.price_summary {\n  .value {\n    >.amount {\n      color: var(--bs-primary);\n    }\n  }\n\n  &.stale {\n    .value {\n      opacity: 0.5;\n      filter: saturate(0);\n    }\n  }\n}\n\n.rdt_TableHead {\n  font-size: 12px !important;\n  font-weight: bold !important;\n}\n\n.rdt_TableHeadRow {\n  background-color: #666 !important;\n  color: white;\n\n  * {\n    overflow: visible !important;\n  }\n}\n\n.rdt_TableRow {\n  padding-top: 10px;\n  padding-bottom: 10px;\n}\n\n.rdt_TableCell {\n  text-align: left;\n  line-height: 20px !important;\n}\n\n.rdt_Table {\n  border: 1px solid rgba(0, 0, 0, 0.12);\n}\n\n.tab-border {\n  border: 1px solid rgb(222, 226, 230);\n  border-top: none;\n}\n\n.active-space {\n  outline: 5px solid blue;\n  z-index: 1;\n}\n\n.replaceable-space {\n  outline: 5px solid red !important;\n  z-index: 1 !important;\n}\n\n.custom-nav-pills {\n  color: #666 !important;\n  border-radius: 50px !important;\n  margin-top: 10px;\n  margin-bottom: 10px;\n}\n\n.custom-nav-pills.active {\n  color: white !important;\n}\n\n.custom-nav-pills-container {\n  margin-top: 15px !important;\n  margin-bottom: 15px !important;\n  background-color: #e5e5e5;\n}\n\n.sub-module-container {\n  cursor: pointer;\n}\n\n.sub-module-container:hover {\n  border: 2px solid;\n  border-color: #0d6efd;\n}\n\n@keyframes blink {\n  0% {\n    opacity: 1;\n  }\n\n  50% {\n    opacity: 0;\n  }\n\n  100% {\n    opacity: 1;\n  }\n}\n\n.disabled-div {\n  pointer-events: none;\n  opacity: 0.4;\n}\n\n.active-dimension {\n  color: #2c92e6;\n}\n\n.active-dimension-outline {\n  outline: 1px solid #2c92e6;\n}\n\n.right-pane-tabs {\n  .tab-item {\n    color: #666;\n    font-weight: bold;\n\n    .icon {\n      height: 16px !important;\n      width: 16px !important;\n    }\n\n    &.active {\n      color: #2c92e6;\n    }\n\n    &:hover {\n      color: #2c92e6;\n    }\n  }\n}\n\n.active-tab {\n  background-color: #2c92e6;\n  color: white;\n}\n\n.inactive-tab {\n  background-color: transparent;\n  color: grey;\n}\n\n.right-nav {\n  width: 70px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-right: 10px;\n  background-color: lightgray;\n}\n\n.active-shutter {\n  outline: 5px solid blue;\n  z-index: 1;\n}\n\n.icon-outline {\n  color: #fcfcfd;\n}\n\n.form-check-input:checked {\n  background-color: #2c92e6 !important;\n  border-color: #2c92e6 !important;\n}\n\n.primary-hover:hover {\n  background-color: transparent !important;\n}\n\n.hover-underline:hover {\n  text-decoration: underline;\n}\n\n.room-canvas-container {\n  &:focus {\n    outline: none !important;\n  }\n}\n\n.wall-node {\n  background-color: #eeeeee;\n  border: 2px solid black;\n}\n\n.modules-container {\n  box-shadow: none !important;\n  padding: 0 !important;\n\n  .modules-listing {\n    padding: 0;\n  }\n\n  .module-card {\n    .card-body {\n      padding: 0;\n      margin-top: 5px;\n      flex-direction: row !important;\n      flex-grow: 1;\n      align-items: center;\n    }\n  }\n}\n\n.tooltip {\n  pointer-events: none;\n\n  .tooltip-inner {\n    white-space: nowrap;\n    max-width: none;\n  }\n}\n\n.rect-selector {\n  position: absolute;\n}\n\n.measurements {\n  position: absolute;\n  z-index: 5000;\n\n  >.measurement-item {\n    position: absolute;\n    display: flex;\n    color: blue;\n\n    >.marker {\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n\n      >.line {\n        flex-grow: 1;\n        background: blue;\n      }\n\n      >.arrow {\n        width: 10px;\n        height: 10px;\n\n        &.down {\n          transform: rotate(180deg);\n        }\n\n        &.left {\n          transform: rotate(-90deg);\n        }\n\n        &.right {\n          transform: rotate(90deg);\n        }\n      }\n    }\n\n    >.text {\n      flex-grow: 1;\n      height: 100%;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      font-size: 20px;\n    }\n\n    &.height {\n      width: 40px;\n\n      >.text {\n        writing-mode: vertical-rl;\n        transform: rotate(180deg);\n      }\n\n      >.marker {\n        width: 20px;\n        flex-direction: column;\n\n        >.line {\n          width: 2px;\n        }\n      }\n\n      &.flipped {\n        flex-direction: row-reverse;\n      }\n    }\n\n    &.width {\n      height: 40px;\n      flex-direction: column-reverse;\n\n      >.marker {\n        height: 20px;\n\n        >.line {\n          height: 2px;\n        }\n      }\n\n      &.flipped {\n        flex-direction: column;\n      }\n    }\n  }\n}\n\n.tab {\n  cursor: pointer;\n  padding: 5px 0;\n  color: black;\n  font-weight: bold;\n}\n\n.tab.active {\n  color: #007bff;\n  border-bottom: 2px solid #007bff;\n}\n\n.hover-border {\n  position: absolute;\n  z-index: 5001;\n  pointer-events: none;\n}\n\n.selection-borders {\n  position: absolute;\n  z-index: 5002;\n  pointer-events: none;\n\n  >.selection {\n    position: absolute;\n  }\n}\n\n.danger-on-hover:hover {\n  color: #dc3545 !important;\n}\n\n.css-1dimb5e-singleValue {\n  height: 25px;\n  display: flex;\n  align-items: center;\n  font-size: 11px !important;\n}\n\n.compact-select {\n  .css-13cymwt-control {\n    min-height: 0;\n  }\n\n  .css-1fdsijx-ValueContainer {\n    padding: 2px 4px !important;\n\n    .css-qbdosj-Input {\n      margin: 0 !important;\n    }\n\n    .css-1dimb5e-singleValue {\n      height: 20px !important;\n      font-size: 10px !important;\n    }\n  }\n}\n\n.pricing-table-container {\n  border: 1px solid #283039;\n  box-shadow: 4px 4px 4px 0px #cccccc;\n  border-radius: 8px;\n  background-color: white;\n}\n\n.pricing-table {\n  border-collapse: collapse;\n}\n\n.pricing-table thead {\n  background-color: #283039;\n  color: white;\n}\n\n.pricing-table th {\n  padding: 12px 20px;\n  text-align: left;\n}\n\n.pricing-table td {\n  padding: 8px 12px;\n  text-align: left;\n}\n\n.pricing-table tbody tr:hover {\n  background-color: #bfc8d099;\n}\n\n.pricing-table .unit {\n  color: #999999;\n}\n\n.details-popup {\n  width: max-content;\n  padding-block: 12px;\n  background: white;\n  border-radius: 8px;\n  z-index: 1000;\n  border: 1px solid #283039;\n  box-shadow: 4px 4px 4px 0px #aaaaaa;\n}\n\n.subtle-gray {\n  color: #aaa;\n}\n\n.less-subtle-gray {\n  color: #888;\n}\n\n.toggle-container {\n  background-color: #ddd;\n  border: 1px solid #e0e0e0;\n  border-radius: 8px;\n  padding: 3px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n}\n\n.toggle-button {\n  padding: 8px 12px;\n  color: #6b7280;\n  cursor: pointer;\n  border-radius: 6px;\n  font-weight: bold;\n}\n\n.toggle-button.active {\n  background-color: #3b82f6;\n  color: white;\n}\n\n.flex {\n  display: flex;\n}\n\n.h-3-em {\n  height: 3em;\n}\n\n.cutlist_table {\n  tr.invalid {\n    td {\n      background: var(--bs-danger);\n      color: #fff;\n    }\n  }\n}\n\ninput::-webkit-outer-spin-button,\ninput::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\ninput[type=\"number\"] {\n  -moz-appearance: textfield;\n}\n\n.dimension.form-control.is-invalid,\n.was-validated .dimension.form-control:invalid {\n  background: none !important;\n  padding-right: 4px !important;\n  border: 2px solid red !important;\n}\n\n.opacity-25 {\n  opacity: 0.25;\n}\n\n.not-allowed-cursor {\n  cursor: not-allowed;\n}\n\n.order-summary {\n  .accordion-item {\n    background: none !important;\n    border: 0;\n  }\n\n  .accordion-button:focus {\n    box-shadow: none !important;\n  }\n\n  .accordion,\n  .accordion-body {\n    display: flex;\n    flex-direction: column;\n    row-gap: 12px;\n  }\n\n  .accordion-body {\n    padding: 12px 0 0 24px;\n  }\n\n  .accordion-button {\n    background-color: transparent !important;\n    border-radius: initial !important;\n    padding: 0 !important;\n    font-size: 14px !important;\n  }\n\n  .accordion-button::before {\n    background-repeat: no-repeat;\n    width: 16px;\n    height: 16px;\n    content: \"\";\n    background-image: url(\"data:image/svg+xml,%3Csvg width='15' height='8' viewBox='0 0 10 8' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1.18333 0.921875L5 4.74337L8.825 0.921875L10 2.09836L5 7.10468L0 2.09836L1.18333 0.921875Z' fill='%23666666'/%3E%3C/svg%3E\");\n    transition: var(--bs-accordion-btn-icon-transition);\n    transform: rotate(-90deg);\n  }\n\n  .accordion-button::after {\n    display: none;\n  }\n\n  .accordion-button:not(.collapsed) {\n    color: black;\n    box-shadow: none;\n  }\n\n  .accordion-button:not(.collapsed)::before {\n    background-image: url(\"data:image/svg+xml,%3Csvg width='15' height='8' viewBox='0 0 10 8' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1.18333 0.921875L5 4.74337L8.825 0.921875L10 2.09836L5 7.10468L0 2.09836L1.18333 0.921875Z' fill='%23666666'/%3E%3C/svg%3E\");\n    transform: rotate(0deg);\n    margin-right: 5px;\n    margin-left: -5px;\n    height: 10px;\n  }\n\n  .dropdown {\n    .order-download:hover {\n      background: none !important;\n    }\n\n    .dropdown-menu {\n      min-width: 6rem;\n      font-size: 12px;\n    }\n\n    .dropdown-menu button {\n      padding: 4px 12px !important;\n    }\n\n    .dropdown-item:hover {\n      background-color: #eeeeee;\n    }\n  }\n}\n\n.project-header {\n  .dropdown {\n    height: 100%;\n    border-left: 1px solid #4f5f71;\n    margin-left: 16px;\n  }\n\n  .dropdown:hover {\n    background-color: #4f5f71;\n  }\n\n  .dropdown button.btn {\n    width: fit-content;\n    height: 100%;\n    padding-inline: 16px;\n  }\n\n  .dropdown-menu {\n    background-color: #283039;\n    box-shadow: 0px 0px 4px 0px #999999;\n  }\n\n  .dropdown-menu button:hover {\n    background-color: #4f5f71;\n    color: white;\n  }\n\n  .align-objects:hover {\n    color: #2c92e6 !important;\n    border-color: #2c92e6 !important;\n  }\n\n  .dropdown-item {\n    color: white;\n  }\n\n  .dropdown-item.disabled {\n    color: gray;\n    pointer-events: auto;\n    cursor: not-allowed;\n  }\n\n  .dropdown-item.disabled:hover {\n    color: gray;\n    background: transparent;\n  }\n}\n\n.clear-icon:hover svg path {\n  stroke: #2c92e6;\n}\n\n.product-type {\n  font-size: 1rem !important;\n}\n\n@media (max-width: 576px) {\n  .product-type {\n    font-size: 0.75rem !important;\n  }\n}\n\n.copied-text {\n  position: absolute;\n  right: 0;\n  top: 0;\n  background: var(--bs-yellow);\n  padding: 2px 5px;\n  border-radius: 0 0 0 10px;\n  border-left: 1px solid #ccc;\n  border-bottom: 1px solid #ccc;\n}\n\n.properties-tab {\n  input[type=\"text\"] {\n    font-size: 11px !important;\n  }\n\n  .accordion-item {\n    background: none !important;\n    border: 0;\n\n    &.padded {\n      .accordion-header {\n        .accordion-button {\n          padding: 8px !important;\n\n          &:hover {\n            background: #e5e5e5 !important;\n          }\n        }\n      }\n\n      .accordion-body {\n        padding: 1rem !important;\n        padding-top: 0.5em !important;\n      }\n    }\n  }\n\n  .accordion-button {\n    background-color: transparent !important;\n    border-radius: initial !important;\n    padding: 0 !important;\n    font-size: 14px !important;\n    text-transform: capitalize;\n  }\n\n  .accordion-button::before {\n    background-repeat: no-repeat;\n    width: 16px;\n    height: 16px;\n    content: \"\";\n    background-image: url(\"data:image/svg+xml,%3Csvg width='15' height='8' viewBox='0 0 10 8' fill='none' stroke='rgb(44 146 230)' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1.18333 0.921875L5 4.74337L8.825 0.921875L10 2.09836L5 7.10468L0 2.09836L1.18333 0.921875Z' fill='%23666666'/%3E%3C/svg%3E\");\n    transition: var(--bs-accordion-btn-icon-transition);\n    transform: rotate(-90deg);\n  }\n\n  .accordion-button::after {\n    display: none;\n  }\n\n  .accordion-button:not(.collapsed) {\n    color: black;\n    box-shadow: none;\n  }\n\n  .accordion-button:not(.collapsed)::before {\n    background-image: url(\"data:image/svg+xml,%3Csvg width='15' height='8' viewBox='0 0 10 8' fill='none' stroke='rgb(44 146 230)' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1.18333 0.921875L5 4.74337L8.825 0.921875L10 2.09836L5 7.10468L0 2.09836L1.18333 0.921875Z' fill='%23666666'/%3E%3C/svg%3E\");\n    transform: rotate(0deg);\n    margin-right: 5px;\n    margin-left: -5px;\n    height: 10px;\n  }\n\n  .accordion-button:focus {\n    box-shadow: none !important;\n  }\n\n  .accordion-body {\n    display: flex;\n    flex-direction: column;\n    row-gap: 12px;\n    padding: 12px 0 0 0;\n  }\n}\n\n.info-header {\n  background-color: #bfc8d0;\n  display: flex !important;\n  justify-content: space-between;\n  align-items: center;\n  border-bottom: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;\n  padding-top: 0.5rem !important;\n  padding-bottom: 0.5rem !important;\n  padding-right: 1rem !important;\n  padding-left: 1rem !important;\n}\n\n.properties-tab .grooves_section .accordion-item {\n  .accordion-body {\n    padding: 0 !important;\n    row-gap: 0px;\n  }\n}\n\n.icon-hover {\n  padding: 6px;\n  color: #333333;\n  font-size: 14px;\n}\n\n.icon-hover:hover {\n  border-radius: 4px;\n  background-color: #d9d9d9;\n}\n\n.unused_color_text {\n  position: absolute;\n  top: 50%;\n  margin-top: -10px;\n  height: 20px;\n  padding-top: 2px;\n  background: black;\n  opacity: 0.5;\n  width: 100%;\n  color: white;\n  text-align: center;\n}\n\n.yellow-color {\n  color: #ffa600;\n}\n\n.show-overflow {\n  overflow: visible !important;\n}\n\n.mb-12px {\n  margin-bottom: 12px !important;\n}\n\n.new-project-summary {\n  .accordion-item {\n    background: none !important;\n  }\n\n  .accordion-body {\n    padding: 0 !important;\n  }\n\n  .accordion-button {\n    background-color: transparent !important;\n    padding: 0 !important;\n    color: inherit !important;\n  }\n\n  .accordion-button:focus {\n    box-shadow: none !important;\n  }\n\n  .accordion-button::after,\n  .accordion-button::before {\n    display: none;\n    margin: 0;\n  }\n\n  .accordion-header {\n    width: 100%;\n  }\n}\n\n.active-item {\n  background: #c0d4e4 !important;\n}\n\n@keyframes smooth-appear {\n  from {\n    transform: translateY(100%);\n    opacity: 0;\n  }\n\n  to {\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n\n@keyframes smooth-hide {\n  from {\n    transform: translateY(0);\n    opacity: 1;\n  }\n\n  to {\n    transform: translateY(100%);\n    opacity: 0;\n  }\n}\n\n.overlay {\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 40vh;\n  min-height: 330px;\n  background-color: #eeeeee;\n  box-shadow: 0px -4px 4px 0px rgba(0, 0, 0, 0.2);\n  z-index: 1000;\n  display: flex;\n  flex-direction: column;\n  border: 1px solid #999999;\n  border-top-left-radius: 20px;\n  border-top-right-radius: 20px;\n  overflow: hidden;\n}\n\n.overlay.show {\n  animation: smooth-appear 0.3s ease forwards;\n}\n\n.overlay.hide {\n  animation: smooth-hide 0.3s ease forwards;\n}\n\n.left-section {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex: 1;\n  /* background-color: white; */\n}\n\n.right-section {\n  display: flex;\n  flex-direction: column;\n  width: 40%;\n  min-width: 150px;\n  font-size: 10px;\n\n  .form-wrapper {\n    border-radius: 15px;\n  }\n}\n\n.content-container {\n  flex: 1;\n  overflow-y: auto;\n  padding: 10px;\n}\n\n.footer-container {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  padding: 0 20px;\n  background-color: #283045;\n  border-top: 1px solid #999999;\n  flex-shrink: 0;\n}\n\n.footer-text {\n  color: #aaaaaa;\n  height: 50px;\n  display: flex;\n  align-items: center;\n}\n\n.footer-button {\n  background-color: #ff344c;\n  color: white;\n  padding: 4px;\n  text-align: center;\n  border-radius: 5px;\n  min-width: 120px;\n  cursor: pointer;\n}\n\n.togle-container {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  font-size: 10px;\n  color: #999999;\n  margin-top: 5px;\n}\n\n.bg-body-dark {\n  background-color: #dddddd;\n}\n\n.modal-popup {\n  position: relative;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.5);\n}\n\n.capital-letter {\n  p::first-letter {\n    text-transform: capitalize;\n  }\n\n  div::first-letter {\n    text-transform: capitalize;\n  }\n}\n\n.direction-filler {\n  border-bottom: #dddddd solid 1px;\n}\n\n.direction-item {\n  padding-bottom: 7px;\n  font-weight: bold;\n}\n\n.w-100px {\n  width: 100px;\n}\n\n.w-50px {\n  width: 50px !important;\n}\n\n.bg-body-light-grey {\n  background-color: #f5f5f5 !important;\n}\n\n.shadow-right {\n  box-shadow: 3px 0px 3px #ddd;\n}\n\n.done-button {\n  border: 1px solid #aaaaaa;\n  border-radius: 5px;\n  background-color: #ffffff;\n  padding-top: 7px;\n  padding-bottom: 7px;\n  padding-left: 20px;\n  padding-right: 20px;\n  cursor: pointer;\n  width: fit-content;\n  color: #666666;\n  font-weight: 500;\n}\n\n.list-summary-select {\n  width: 250px !important;\n}\n\n.min-height-38px {\n  min-height: 38px;\n}\n\n.transform-x-negative-half {\n  transform: translate(-50%, 0px);\n}\n\n.loader-grey {\n  background-color: #cccccc !important;\n}\n\n.h-10px {\n  height: 10px;\n}\n\n.highlight_property {\n  background: #fff5cc;\n}\n\n.status-active {\n  .dimension {\n    background: #fff;\n  }\n}\n\n.bg-pink {\n  background-color: #fdebeb;\n}\n\n.border-danger {\n  border-color: #dc3545 !important;\n}\n\n.icon-red {\n  color: #dc3545;\n}\n\n.icon-black {\n  color: black;\n}\n\n.icon-white {\n  color: wheat;\n}\n\n/* Custom filter pill styles */\n.reports-filter-btn {\n  border: 1px solid #ccc;\n  background-color: #f8f9fa;\n  color: #000;\n  font-size: 0.85rem;\n  padding: 2px 10px;\n  border-radius: 0.25rem;\n  cursor: pointer;\n\n  &:hover {\n    background-color: #e2e6ea;\n  }\n}\n\n.reports-filter-active {\n  background-color: #343a40;\n  color: #fff;\n\n  &:hover {\n    background-color: #343a40;\n  }\n}\n\n/* Custom table header */\n.reports-custom-table-header th {\n  color: #fff !important;\n  font-weight: bold;\n}\n\n@keyframes highlightFade {\n  0% {\n    background-color: #ffe58a;\n    /* Start: light yellow */\n  }\n\n  100% {\n    background-color: transparent;\n    /* End: transparent */\n  }\n}\n\n.highlighted {\n  animation: highlightFade 2s ease forwards;\n}\n\n.fs-35px {\n  font-size: 35px;\n}\n\n.fs-28px {\n  font-size: 28px;\n}\n\n.fs-20px {\n  font-size: 20px;\n}\n\n.fs-16px {\n  font-size: 16px !important;\n}\n\n@media (min-width: 768px) {\n  .fs-md-50px {\n    font-size: 50px;\n  }\n\n  .fs-md-30px {\n    font-size: 30px;\n  }\n\n  .fs-md-20px {\n    font-size: 20px !important;\n  }\n}\n\n.overriden-text-input::placeholder {\n  color: black !important;\n}\n\n.placeholder-grey::placeholder {\n  color: #AAAAAA !important;\n}\n\n.preview-btn {\n  width: 20%;\n  z-index: 1000;\n}\n\n.overriden-focus-text {\n  color: black;\n}\n\n.placeholder-grey-text {\n  color: #aaaaaa;\n}\n\n.expo-toggle-switch {\n  width: 70px;\n  height: 26px;\n}\n\n.expo-toggle-switch .slider {\n  background-color: #ccc;\n  border-radius: 34px;\n  transition: 0.4s;\n  padding-left: 20px;\n}\n\n.expo-toggle-switch .slider:before {\n  content: \"\";\n  position: absolute;\n  height: 18px;\n  width: 18px;\n  left: 4px;\n  bottom: 4px;\n  background-color: white;\n  border-radius: 50%;\n  transition: 0.4s;\n}\n\n.expo-toggle-switch input:checked + .slider {\n  background-color: #2196f3;\n  padding-left: 20px;\n  padding-right: 30px;\n}\n\n.expo-toggle-switch input:checked + .slider:before {\n  transform: translateX(44px);\n}\n\n.expo-toggle-switch .slider span {\n  position: relative;\n  transition: 0.4s;\n  transform: translateX(1px);\n  font-size: 12px;\n}\n\n.expo-toggle-switch input:checked + .slider span {\n  transform: translateX(-7px);\n}\n\n.hover-bg:hover {\n  background-color: #f5f5f5;\n}\n.context-menu-item {\n  padding: 8px 16px;\n  cursor: pointer;\n}\n\n.context-menu-item:hover {\n  background-color: #f0f0f0;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
